module.exports = __webpack_public_path__ + "img/en.73dd2348.jpg";